export const isEmpty = (value?: string | unknown[] | null) => !value || value.length === 0;
